import React from 'react'
import Button from '@react/react-spectrum/Button'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import Download from '@react/react-spectrum/Icon/Download'

function go (evt, referrer) {
    analytics.sendEventName('download', `${referrer}:extension`)
    window.open(
        __('url_download_extension'),
        '_blank'
    )
}

export default function DownloadExtensionButton (props) {
    const { referrer } = props
    return (
        <Button
            {...props}
            label={__('nav_download_extension')}
            onClick={(evt) => go(evt, referrer)}
            variant="cta"
            icon={<Download />}
        />
    )
}
